*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  display: block;
}

.title {
  margin: 0;
  font: inherit;
}

.list {
  margin: 0;
  padding: 0;
}